import React from "react";
import { Link } from "react-router-dom";
import error from "./assets/error-404-colour.svg";

const Pagenotfound = () => {
  return (
    <div className="fourzerofourpage">
      <img src={error} width="100%" height="70%" alt="" className="mt-3" />
      <h6 className=" text-center text-white font-weight-bold text-dark existtext  mt-3">
        The page you were looking for doesn't exist
      </h6>
      <div className="text-center mt-5">
        <Link to="/">
          <button
            className="btn fourzerofourbtn text-white"
            style={{ backgroundColor: "#FCCE01", borderRadius: "0" }}
          >
            Go Home
          </button>
        </Link>
      </div>
      {/* <div className="fourzerofourposition">
        <h1 className="text-muted text-center fourzerofour">404 </h1>
        <h6 className="text-center font-weight-bold text-white">
          The page you were looking for doesn't exist
        </h6>
        <div className="text-center mt-5">
          <Link to="/">
            <button
              className="btn fourzerofourbtn text-white"
              style={{ backgroundColor: "#FCCE01", borderRadius: "0" }}
            >
              Go Home
            </button>
          </Link>
        </div>
      </div> */}
    </div>
  );
};

export default Pagenotfound;
